export default __webpack_public_path__ + "static/734-0c3e843517b79b300e3b91439a9f7aab.gif";